import templateUrl from 'emun.order/order-header-fieldset.htm'
import templateUrlMin from 'emun.order/order-header-fieldset-min.htm'
import templateUrlSummary from 'emun.order/order-header-fieldset-summary.htm'
import controller from 'emun.order/order-header-fieldset.controller'

export default {
    bindings: {
        order: '<',
        showVendor: '@',
		onCreateContact: '&'
    },
    controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || $attrs.type === "min" ? templateUrlMin : $attrs.type === "summary" ? templateUrlSummary : templateUrl;
    }
}